module.exports = __webpack_public_path__ + "img/1.6df964f5.webp";